<template>
  <div class="row">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'row',
  created () {

  }
}
</script>



// WEBPACK FOOTER //
// Row.vue?1c4ffb1e